import React, { useEffect, useState } from "react";
import { FileText, Printer, X, Loader2 } from "lucide-react";
import InvoiceDocument from "@/components/InvoiceDocument";
import { api } from "@/lib/api";

const TONE = {
  "Paid": "text-emerald-300 border-emerald-500/30 bg-emerald-500/10",
  "Partially Paid": "text-amber-300 border-amber-500/30 bg-amber-500/10",
  "Overdue": "text-red-300 border-red-500/30 bg-red-500/10",
  "Sent": "text-blue-300 border-blue-500/30 bg-blue-500/10",
  "Cancelled": "text-white/50 border-white/20 bg-white/5",
};
const tone = (s) => TONE[s] || "text-white/70 border-white/20 bg-white/5";

export default function AccountInvoices() {
  const [items, setItems] = useState(null);
  const [view, setView] = useState(null);
  useEffect(() => { api.get("/client/invoices").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);

  return (
    <div className="space-y-6" data-testid="account-invoices">
      <div><p className="kicker mb-1">My Ascendia</p><h1 className="font-display text-2xl sm:text-3xl font-semibold text-white">My invoices</h1></div>
      {items === null ? <p className="text-sm text-muted-c">Loading…</p> : items.length === 0 ? (
        <div className="ascendia-card p-10 text-center"><FileText className="h-8 w-8 text-gold-soft mx-auto" /><p className="mt-4 text-white font-medium">No invoices yet</p><p className="mt-1 text-sm text-muted-c">Your invoices will appear here once issued.</p></div>
      ) : (
        <div className="space-y-3" data-testid="client-invoices-list">
          {items.map((inv) => (
            <div key={inv.id} className="ascendia-card p-5 flex flex-wrap items-center justify-between gap-4">
              <div>
                <div className="flex items-center gap-3"><span className="font-mono text-xs text-gold-soft">{inv.number}</span><span className={`text-[11px] px-2 py-0.5 rounded-full border ${tone(inv.status)}`}>{inv.status}</span></div>
                <p className="mt-2 text-white font-medium">{inv.currency}{Number(inv.total).toLocaleString()} <span className="text-sm text-muted-c">· due {(inv.due_date || "").slice(0, 10)}{inv.balance > 0 ? ` · ${inv.currency}${Number(inv.balance).toLocaleString()} due` : ""}</span></p>
              </div>
              <button onClick={() => setView(inv)} data-testid={`view-invoice-${inv.id}`} className="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border-subtle)] px-4 py-2.5 text-sm text-white hover:bg-white/5"><FileText className="h-4 w-4" /> View</button>
            </div>
          ))}
        </div>
      )}
      {view && (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-black/70 py-8 px-4" onClick={() => setView(null)}>
          <div className="no-print max-w-[800px] mx-auto mb-4 flex justify-between" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setView(null)} className="inline-flex items-center gap-2 rounded-xl border border-white/20 px-4 py-2 text-sm text-white hover:bg-white/10"><X className="h-4 w-4" /> Close</button>
            <button onClick={() => window.print()} data-testid="client-invoice-print" className="inline-flex items-center gap-2 rounded-xl bg-gold px-5 py-2 text-sm font-semibold text-black hover:bg-gold-soft"><Printer className="h-4 w-4" /> Print / Download</button>
          </div>
          <div onClick={(e) => e.stopPropagation()}><InvoiceDocument inv={view} /></div>
        </div>
      )}
    </div>
  );
}
